import { useEffect } from 'react';
import { SITE_CHATBOT_ID } from '../config/chatbaseAgents';

// ============================================================================
//  Nordic Digitals egen AI-assistent (Chatbase) — vises på hele hjemmesiden.
//  Indsæt chatbot-ID i SITE_CHATBOT_ID i src/config/chatbaseAgents.js.
//  Er ID'et tomt, indlæses intet (ingen fejl).
// ============================================================================

function SiteChatbot() {
  useEffect(() => {
    if (!SITE_CHATBOT_ID) return undefined;

    if (!window.chatbase || window.chatbase('getState') !== 'initialized') {
      window.chatbase = (...args) => {
        if (!window.chatbase.q) window.chatbase.q = [];
        window.chatbase.q.push(args);
      };
      window.chatbase = new Proxy(window.chatbase, {
        get(target, prop) {
          if (prop === 'q') return target.q;
          return (...args) => target(prop, ...args);
        }
      });
    }

    const script = document.createElement('script');
    script.src = 'https://www.chatbase.co/embed.min.js';
    script.id = SITE_CHATBOT_ID;
    script.setAttribute('domain', 'www.chatbase.co');
    document.body.appendChild(script);

    return () => {
      const el = document.getElementById(SITE_CHATBOT_ID);
      if (el) el.remove();
      document.querySelectorAll('iframe[src*="chatbase"], [id^="chatbase-bubble"]').forEach((n) => n.remove());
    };
  }, []);

  return null;
}

export default SiteChatbot;
